// @ts-strict-ignore
import { createReducer, on } from '@ngrx/store';
import * as HardwareActions from '@fc-store/actions/hardware.actions';
import { Hardware } from '@fc-core';

export const hardwareFeatureKey = 'hardware';

export interface State {
  hardwareSearch: Hardware[];
  hardwareList: Hardware[];
}

export const initialState: State = {
  hardwareSearch: null,
  hardwareList: null,
};

export const reducer = createReducer(
  initialState,
  on(HardwareActions.searchHardware, (state) => state),
  on(HardwareActions.searchHardwaresSuccess, (state, action) => ({
    ...state,
    hardwareSearch: action.data,
  })),

  on(HardwareActions.searchHardwaresFailure, (state) => state),
  on(HardwareActions.getAllHardwareSuccess, (state, action) => ({
    ...state,
    hardwareList: action.data,
  })),
);

export const getAllHardware = (state: State) => state.hardwareList;
